module.exports = __webpack_public_path__ + "img/hi_icon.cf9e53cb.png";